import api from "./api";

class DashboardAPI {

  async getTotais(headers, params) {
    const response = await api.get("/dash_totais", { params, headers });
    return response;
  }

  async getAssessores(headers, params) {
    const response = await api.get("/dash_assessores", { params, headers });
    return response;
  }


  async getValidateUser(headers) {
    const response = await api.get("/me", { headers });
    return response;
  }


  async getCandidatos(headers, params) {
    const response = await api.get("/dash_candidatos", { params, headers });
    return response;
  }


}

export default new DashboardAPI();